import type { GameId } from "modules/common/model/models";
import { getGameMetadata } from "modules/common/gameRegistry";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";

interface GameIconProps {
  game: GameId;
  /** Compact glyph by default; use brand for large decorative surfaces. */
  variant?: "compact" | "brand";
  /** Pixel size; defaults to the global ICON_SIZE so callers can pass it through props. */
  size?: number;
  /** Color override; falls back to bundled or neutral presentation metadata. */
  color?: string;
  className?: string;
}

/**
 * Canonical game-identity renderer for every app surface. Every valid manifest
 * ID receives the generic card-stack fallback; bundled games resolve their
 * registry-owned official mark here.
 */
export function GameIcon({
  game,
  variant = "compact",
  size = ICON_SIZE,
  color,
  className,
}: GameIconProps) {
  const registration = getGameMetadata(game);
  const renderer =
    variant === "brand"
      ? (registration.presentation.renderBrandMark ??
        registration.presentation.renderIcon)
      : registration.presentation.renderIcon;

  return renderer({
    size,
    color: color ?? registration.brandColor,
    className,
  });
}
